var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNhsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28844",
    "data-name": "Group 28844",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.225,
    height: 32.89,
    viewBox: "0 0 82.225 32.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140125",
    "data-name": "Path 140125",
    d: "M0,0H82.225V32.89H0Z",
    fill: "#005eb8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140126",
    "data-name": "Path 140126",
    d: "M6.856,1.922H15.9l5.345,18.5h.206l3.7-18.5h6.784L26.179,28.645H17.34l-5.55-18.5h-.206l-3.7,18.5H1.1M34.4,1.922h7.4L39.746,11.995h8.223L50.23,1.922h7.195l-5.55,26.723H44.679l2.261-11.512H38.513L36.046,28.645H29.057M76.336,7.884A14.377,14.377,0,0,0,70.375,6.65c-2.878,0-5.139.411-5.139,2.672,0,3.7,10.484,2.467,10.484,10.484,0,7.4-6.784,9.25-13.156,9.25a26.52,26.52,0,0,1-8.223-1.439l1.645-5.55a15.548,15.548,0,0,0,6.578,1.439c2.261,0,5.756-.411,5.756-3.083,0-4.317-10.484-2.672-10.484-10.278C57.835,3.156,63.8,1.1,69.758,1.1a22.335,22.335,0,0,1,8.223,1.233",
    transform: "translate(1.161 1.161)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhsLogo);
export default __webpack_public_path__ + "static/media/nhs-logo.b900c3da583632b2aa1fe6be05631e1b.svg";
export { ForwardRef as ReactComponent };